// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/intent-reversal-alerts.less
// module id = 3376
// module chunks = 0